import { lazy, useEffect } from "react";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import {
  ACCEPT_TERMS_ROUTE,
  ACCESS_REDIRECT_ROUTE,
  DASHBOARD_ROUTE,
  HOME_ROUTE,
  RESET_PASSWORD_ROUTE,
  ALLOW_CASINO,
  useAppDispatch,
} from "@hypexone/uicore";
import { useAppSelector } from "@hypexone/uicore";
import ProtectedRoute from "./ProtectedRoutes";
import SportsView from "../sports-view/SportsView";
import SportsLayout from "../../../layouts/SportsLayout";
import { protectedRoutesConfig, routesConfig } from "./routesConfig";
import VirtualMarket from "../all-markets/virtual-market/VirtualMarket";
import { isIOS, isMobile } from "react-device-detect";
import YuviGames from "../YuviGames/YuviGames";
import NoMarkets from "../sidebar/NoMarkets";

const HomePage = lazy(() => import("../../pages/HomePage"));
const AllMarkets = lazy(() => import("../all-markets/AllMarkets"));

const UserRouter = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { loggedIn, jwtToken } = useAppSelector((state) => state.auth);
  const dispatch = useAppDispatch();
  let claim = jwtToken?.split(".")?.[1] || "";
  const role = loggedIn ? JSON.parse(window.atob(claim)).role : null;
  const status = loggedIn ? JSON.parse(window.atob(claim)).sts : -1;

  const sportRoutes: { path: string; component: JSX.Element }[] = [
    {
      path: HOME_ROUTE,
      component: <HomePage />,
    },
    {
      path: DASHBOARD_ROUTE,
      component: <SportsLayout />,
    },
    {
      path: "/exchange_sports/:eventType",
      component: <SportsLayout />,
    },
    {
      path: "/exchange_sports/sports/:eventType",
      component: <SportsLayout />,
    },
    {
      path: "/sports_events",
      component: <SportsLayout />,
    },
    {
      path: "/exchange_sports/:eventType/:competition/:eventId/:eventInfo",
      component: <AllMarkets />,
    },
    {
      path: "/exchange_sports/virtuals/:eventType/:competition/:eventId/:eventInfo",
      component: <VirtualMarket />,
    },
    {
      path: "/no-markets",
      component: <NoMarkets />,
    }
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);


  useEffect(() => {
    if (loggedIn) {
      const claim = sessionStorage.getItem("jwt_token").split(".")[1];
      let status = JSON.parse(window.atob(claim)).sts;

      if (status === 2) {
        navigate(ACCEPT_TERMS_ROUTE, { replace: true });
      } else if (status === 4) {
        navigate(RESET_PASSWORD_ROUTE, { replace: true });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loggedIn])


  return (
    <div className="w-full router-ctn">
      <main className="flex w-full">
        {status !== -1 && status === 4 ? (
          <Navigate to={ACCEPT_TERMS_ROUTE} />
        ) : status !== -1 && status === 2 ? (
          <Navigate to={ACCEPT_TERMS_ROUTE} />
        ) : role && role !== "User" ? (
          <Navigate to={ACCESS_REDIRECT_ROUTE} />
        ) : !ALLOW_CASINO &&
          (window.location.pathname.includes("/casino") ||
            window.location.pathname.includes("/dc/gamev1.1/")) ? (
          <Navigate to={ACCESS_REDIRECT_ROUTE} />
        ) : (
          <div className="w-full">
            <div className=" ">
              <Routes>
                {routesConfig.map((route, index) => (
                  <Route
                    key={index}
                    path={route.path}
                    element={<route.component />}
                  />
                ))}
                <Route element={<SportsView />}>
                  {sportRoutes.map((route, index) => (
                    <Route
                      key={index + "protected"}
                      path={route.path}
                      element={route.component}
                    />
                  ))}
                </Route>
                <Route element={<ProtectedRoute isAuthenticated={loggedIn} />}>
                  {protectedRoutesConfig.map((route, index) => (
                    <Route
                      key={index + "protected"}
                      path={route.path}
                      element={<route.component />}
                    />
                  ))}
                </Route>
              </Routes>
            </div>
          </div>
        )}
      </main>
       {(isMobile || isIOS) ? <YuviGames /> : null}
    </div>
  );
};

export default UserRouter;
